import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesPipelineBoardView } from "src/components/views/erp/sales/crm/salesPipeline/SalesPipelineBoardView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/crm/salesPipelineBoard")({
	staticData: { title: i18n.t("sales_pipeline"), legacyViewKey: "salesPipelineBoardView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesPipelineBoardView />;
}
